  <div class="grid" [formGroup]="form">
    <div class="col-12 md:col-4">
      <p-dropdown [options]="fields" formControlName="fieldType" placeholder="Что меняем" styleClass="w-full" optionLabel="label"
        optionValue="value" [showClear]="true"></p-dropdown>
    </div>
    <div class="col-12 md:col-4">
      <p-selectButton [options]="stateOptions" formControlName="boolValue" optionLabel="label" optionValue="value">
      </p-selectButton>
    </div>
    <div class="col-12 md:col-4">
      <p-calendar formControlName="dateValue"
      [showTime]="true" [showSeconds]="true" styleClass="w-full"
      [showIcon]="true" [dateFormat]="'yy-mm-dd'" [dataType]="'string'" >
    </p-calendar>
    </div>
  </div>

  <p-toolbar>
    <div class="p-toolbar-group-left">
      <button pButton type="button" label="Сохранить" class="p-button-success" (click)="onSubmit()"></button>
    </div>
    <div class="p-toolbar-group-right">
      <button pButton type="button" label="Отмена" class="p-button-secondary" (click)="onCancel()"></button>
    </div>
  </p-toolbar>
